"use client";

// src/link.tsx
import { cn } from "@momo/utils";
import { cva } from "class-variance-authority";
import NextLink from "next/link";
import { jsx } from "react/jsx-runtime";
var linkVariants = cva("", {
  variants: {
    variant: {
      muted: "text-muted-foreground hover:text-foreground transition-colors"
    }
  }
});
var Link = (props) => {
  const { href, className, children, variant, ...rest } = props;
  if (href.startsWith("/")) {
    return /* @__PURE__ */ jsx(NextLink, { className: cn(linkVariants({ variant, className })), href, ...rest, children });
  }
  if (href.startsWith("#")) {
    return /* @__PURE__ */ jsx("a", { className: cn(linkVariants({ variant, className })), href, ...rest, children });
  }
  return /* @__PURE__ */ jsx(
    "a",
    {
      className: cn(linkVariants({ variant, className })),
      target: "_blank",
      rel: "noopener noreferrer",
      href,
      ...rest,
      children
    }
  );
};

export {
  linkVariants,
  Link
};
